export default __webpack_public_path__ + "static/media/AdvancedReact_-_adamr.space___Codecademy.8fa76f18.pdf";